import useUsersMasterTable from 'hooks/service/useUsersMasterTable';
import styled from 'styled-components';

const MasterKidInfoBlock = styled.div`
  .title {
    margin-top: 1rem;
  }

  .box {
    margin-top: 1rem;
    padding: 1rem 2rem;
    display: flex;
    flex-direction: column;
  }

  .table-header {
    display: flex;
    justify-content: space-between;
    font-weight: bold;

    div {
      width: 100%;
      text-align: center;
    }
  }

  .table-row {
    margin-top: 0.5rem;
    display: flex;
    justify-content: space-between;
    position: relative;

    div {
      width: 100%;
      text-align: center;
    }
  }
`;

const MasterKidInfo = () => {
  const { getMasterUsers, userType } = useUsersMasterTable();

  if (userType !== '2') return <></>;

  const data = getMasterUsers.data?.data.kids;

  return (
    <MasterKidInfoBlock>
      <div className="title">Master Kid</div>
      <div className="box">
        <div className="table-header">
          <div>Master Kid ID</div>
          <div>사용자</div>
          <div>사원번호</div>
          <div>연락처</div>
        </div>
        <div className="table-row">
          <div>{data?.userId}</div>
          <div>{data?.name ? data?.name : '미입력'}</div>
          <div>{data?.code ? data?.code : '미입력'}</div>
          <div>{data?.tel ? data?.tel : '미입력'}</div>
        </div>
      </div>
    </MasterKidInfoBlock>
  );
};

export default MasterKidInfo;
